export const GET_IS_PROGRESS = 'GET_IS_PROGRESS';
export const GET_FORM_STEPS = 'GET_FORM_STEPS';
export const GET_ACTIVE_STEP = 'GET_ACTIVE_STEP';
export const GET_IS_SUBMIT_INPROGRESS = 'GET_IS_SUBMIT_INPROGRESS';
export const GET_IS_REQUEST_SUCCESS = 'GET_IS_REQUEST_SUCCESS';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_ORG_PRE_FILL_DATA = 'GET_ORG_PRE_FILL_DATA';
export const GET_ORG_INFO = 'GET_ORG_INFO';
export const GET_READONLY_ORG_INFO = 'GET_READONLY_ORG_INFO';
